/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateAppOrderRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {CreateAppOrderResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const createAppOrder = (request: CreateAppOrderRequest, options?: CashRequestOptions) => post<CreateAppOrderRequest, CreateAppOrderResponse>("/cash-app/local/app/order", request, {...options, rejectOnError: true })